import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "errorId", "isError", "isErrorCredits", "paddingInline", "onRetry"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorPanel } from '../ErrorPanel';
import { ErrorCredits } from '../EnrichmentPropertiesPanel/EnrichmentPropertiesError/ErrorCredits';
import { LayoutBox } from 'breeze-intelligence-kit';
import { BasePanel } from '../Panel/BasePanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SmartPropertiesError = _ref => {
  let {
      children,
      errorId,
      isError,
      isErrorCredits = false,
      paddingInline = 'space-lg',
      onRetry
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (isError) {
    if (isErrorCredits) {
      return /*#__PURE__*/_jsx(BasePanel.Body, {
        children: /*#__PURE__*/_jsx(ErrorCredits, {
          errorId: errorId !== null && errorId !== void 0 ? errorId : '',
          onSubmit: onRetry !== null && onRetry !== void 0 ? onRetry : () => {}
        })
      });
    }
    return /*#__PURE__*/_jsx(BasePanel.Body, {
      children: /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
        paddingInline: paddingInline,
        children: /*#__PURE__*/_jsx(ErrorPanel, {
          errorId: errorId !== null && errorId !== void 0 ? errorId : '',
          onSubmit: onRetry !== null && onRetry !== void 0 ? onRetry : () => {},
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartProperties.panel.error.generic.title"
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartProperties.panel.error.generic.description"
          })
        })
      }))
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};